import React from "react";
import IndexSearchContainer from "../components/home/IndexSearchContainer";

//code for session
import { sessionTimeOutCheck, checkExpiry } from "../redux/global/actions.js";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import Modal from "../pages/successModal/index";
import Loading from "../components/Loader/index.jsx";
import endpoints from "../utility/endpoints.js";
import axios from "axios";
import { useRouter } from "next/router";
import { useEffect, useState } from "react";

const Home = (props) => {
  //code for session
  const router = useRouter();
  const currentUrl = router.asPath;
  const [successModal1, setSuccessModal1] = useState(false);
  const checkAuthorization = async () => {
    let authData = JSON.parse(localStorage.getItem("auth"));
    if (!authData || !authData.data) {
      // Handle the case when authData or authData.data is falsy
      props.sessionTimeOutCheck(true);

      return; // Return without making the API call
    }
    try {
      let auth = JSON.parse(localStorage.getItem("auth")).data;
      const { data } = await axios({
        method: "GET",
        url: `${endpoints.baseUrl}/roi/checkAuthorization`,
        headers: {
          Authorization: `${auth.accessToken}|${auth.email}`,
        },
      });
      if (data.data.code === 200) {
      } else if (data.code === 403) {
        setTimeout(() => {
          props.sessionTimeOutCheck(true);
        }, 1000);
      } else {
        props.sessionTimeOutCheck(true);
      }
    } catch (error) {
      console.log("Error in Authorization", error);
    }
  };
  useEffect(() => {
    checkAuthorization();
  }, []);

  return (
    <>
      {props.routeChangeState ? (
        <div style={{ height: "800px" }}>
          <Loading />
        </div>
      ) : (
        <>
          <IndexSearchContainer />
          {props.session ? (
            <Modal
              message={"Session Expired"}
              title={"Login Session Status"}
              session={props.session}
              sessionTimeOutCheck={props.sessionTimeOutCheck}
              setSuccessModal={setSuccessModal1}
              fail={true}
              checkoutSessionCheck={"checkoutSessionCheck"}
            />
          ) : null}
        </>
      )}
    </>
  );
};

//code for session
const mapStateToProps = (state) => {
  return {
    session: state.session.session,
  };
};

function mapDispatchToProps(dispatch) {
  return {
    sessionTimeOutCheck: bindActionCreators(sessionTimeOutCheck, dispatch),
    checkExpiry: bindActionCreators(checkExpiry, dispatch),
  };
}
export default connect(mapStateToProps, mapDispatchToProps)(Home);

